import { render } from "./BaseModal.vue?vue&type=template&id=d43b515a&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=ts"
export * from "./BaseModal.vue?vue&type=script&lang=ts"

import "./BaseModal.vue?vue&type=style&index=0&id=d43b515a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d43b515a"

export default script